import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC2Oi55KT4PsmgxWXmsGuGr4TsuW5kgRR0",
  authDomain: "d3ri-7e044.firebaseapp.com",
  projectId: "d3ri-7e044",
  storageBucket: "d3ri-7e044.firebasestorage.app",
  messagingSenderId: "184778408847",
  appId: "1:184778408847:web:90788ace38028201b041fa"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
